import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoaderService implements OnInit {
  public loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  private pendingRequests = 0;
  private showTimer: any = null;

  constructor(public spinner: NgxSpinnerService, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.forceHide();
      }
    });
  }

  ngOnInit(): void {}

  show(immediate: boolean = true) {
    this.pendingRequests++;
    this.activate();
  }

  hide() {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);

    if (this.pendingRequests === 0) {
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = null;
      }
      if (this.loading.value) {
        this.loading.next(false);
        document.body.classList.remove('loading-active');
        try {
          this.spinner.hide();
        } catch (e) {}
      }
    }
  }

  forceHide() {
    this.pendingRequests = 0;
    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }
    if (this.loading.value) {
      this.loading.next(false);
      document.body.classList.remove('loading-active');
      try {
        this.spinner.hide();
      } catch (e) {}
    }
  }

  private activate() {
    this.loading.next(true);
    document.body.classList.add('loading-active');
    try {
      this.spinner.show();
    } catch (e) {}
  }
}

